import {useRouter} from 'next/router';
import {useMemo} from 'react';

/** SSR / pre-hydration marketing URL when `window` is unavailable */
export function getPersonalPlanMarketingUrlWithoutWindow(
    canonicalUrl: string,
    isReady: boolean | undefined,
    asPath: string | undefined,
): string {
    const origin = new URL(canonicalUrl).origin;
    if (isReady) {
        return `${origin}${asPath}`;
    }

    return `${origin}/personal-plan/`;
}

/**
 * Marketing URL for subscription plan pricing queries. On the client, uses the live browser URL so
 * coupon query params are included on the first fetch (before Next router hydration).
 */
export function usePersonalPlanMarketingUrl(canonicalUrl: string): string {
    const router = useRouter();

    return useMemo(() => {
        if (typeof window !== 'undefined') {
            return `${window.location.origin}${window.location.pathname}${window.location.search}`;
        }

        return getPersonalPlanMarketingUrlWithoutWindow(
            canonicalUrl,
            router?.isReady,
            router?.asPath,
        );
    }, [canonicalUrl, router?.isReady, router?.asPath]);
}
